import React from 'react';
import SwiperCore from 'swiper';
import { Pagination } from 'swiper/modules';

import 'swiper/css';
import { Swiper, SwiperSlide } from 'swiper/react';
import style from './style.module.scss';
import LinesEllipsis from 'react-lines-ellipsis';
import responsiveHOC from 'react-lines-ellipsis/lib/responsiveHOC';

const Results = ({ results }) => {
    SwiperCore.use([Pagination]);
    const ResponsiveEllipsis = responsiveHOC()(LinesEllipsis);

    if (!results) {
        return <></>;
    }

    const pages = results.reduce((resultArray, item, index) => {
        const chunkIndex = Math.floor(index / 6);

        if (!resultArray[chunkIndex]) {
            resultArray[chunkIndex] = []; // start a new chunk
        }
        resultArray[chunkIndex].push(item);
        return resultArray;
    }, []);

    const swiperSettings = {
        slidesPerView: '1',
        spaceBetween: 40,
        loop: false,
        pagination: pages.length > 1 && {
            clickable: true,
            renderBullet: function (index, className) {
                return '<span class="' + className + '">' + (index + 1) + '</span>';
            },
        },
    };

    return (
        <Swiper {...swiperSettings} className={style.slider}>
            {pages &&
                pages.map((page, index) => (
                    <SwiperSlide key={index}>
                        <ul>
                            {page.map((res) => (
                                <a href={res.document.permalink} className={style.link}>
                                    <li className={style.result}>
                                        {res.highlights[0].field === 'post_title' ? (
                                            <p
                                                className={style.title}
                                                dangerouslySetInnerHTML={{ __html: res.highlights[0].snippet }}
                                            />
                                        ) : (
                                            <p className={style.title}>{res.document.post_title}</p>
                                        )}
                                        {res.document.post_excerpt && (
                                            <p className={style.excerpt}>
                                                <ResponsiveEllipsis
                                                    text={res.document.post_excerpt}
                                                    maxLine={2}
                                                    ellipsis="..."
                                                    basedOn="words"
                                                />
                                            </p>
                                        )}
                                    </li>
                                </a>
                            ))}
                        </ul>
                    </SwiperSlide>
                ))}
        </Swiper>
    );
};

export default Results;
